import expressionatorMethod from "@/utils/expressionator.util"

export default {
  computed: {
    expressionator() {
      return (val, fields) => expressionatorMethod(val, fields)
    }
  }
}